
import React, { useState,useEffect,useContext } from "react"
import './../App.css';
import hero from './../data/Unit.json';
import { AppContext } from "./../context/AppContext";
import TeamSlot from "./../components/TeamSlot";
import {toPng} from 'html-to-image';
import download from 'downloadjs';
import { useSearchParams } from "react-router-dom";
import './../styles/Select.scss';
import Modal from 'react-modal';
Modal.setAppElement('#root');

function Main() {
	// eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchQ,setSearchQ] = useState("");
  	const [typeList,setTypeList] = useState([{"id":4,"name":"Shimmer","show": true},{"id": 1,"name":"Inferno","show": true},{"id": 2,"name": "Wind",show: true},{"id": 3,"name":"Flow",show: true}]);
	const [starList,setStarList] = useState([{"nb": 3,show: true},{"nb": 4,show: true},{"nb": 5,show: true}]);
	const [filterByCollection,setFilterByCollection] = useState(false);
	const [esperList,setEsperList] = useState(hero.filter((h) => h.Enable === true && h.HeroType === "Hero").map(
		x => {
			x.set1 = null;
			x.set2= null;
			x.stat1 = null;
			x.stat2 = null;
			x.stat3 = null;
			x.currentLevel = 60;
			x.bonusATK = 0;
			x.bonusHP = 0;
			x.bonusDEF = 0;
			x.bonusSPEED = 0;
			x.bonusCRP = 0;
			x.bonusCRD = 0;
			x.bonusACC = 0;
			x.bonusRES = 0;
			x.show = true;
			return x;
		}));
	const {searchKey,translate,collection} = useContext(AppContext);
	const [teamList,setTeamList] = useState([null,null,null,null,null]);
	const [modalIsOpen, setIsOpen] = useState(false);
	const [screenshotTitle,setScreenshotTitle] = useState("");
	const [showScreenshotStat,setShowScreenshotStat] = useState(false);
	const [showRelics,setShowRelics] = useState(true);


    const search = (e) => {
		e.preventDefault();
		let currentSearch = e.target;
		setSearchQ(currentSearch.value);
	}
  	const toggleType = (e) => {
		e.preventDefault();
		let currentType = e.target;
		if(currentType.checked) {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = true;
				}
				return t;
			})
			setTypeList(temp)
		} else {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = false;
				}
				return t;
			})
			setTypeList(temp)
		}
  	}
	const toggleNone = (e,type) => {
		if(type === "type") {
			let temp = typeList.map((t) => {
				t.show = false;
				return t;
			})
			setTypeList(temp);
		} else if(type === "star") {
			let temp = starList.map((t) => {
				t.show = false;
				return t;
			})
			setStarList(temp);
		}
		e.preventDefault();
    }
	const toggleAll = (e,type) => {
        if(type === "type"){
			let temp = typeList.map((t) => {
				t.show = true;
				return t;
			})
			setTypeList(temp)
		} else {
			let temp = starList.map((t) => {
				t.show = true;
				return t;
			})
			setStarList(temp)
		}
        e.preventDefault();
    }
	const toggleStar = (e) => {
		let currentStar = e.target;
		if(currentStar.checked) {
			let temp = starList.map((t) => {
				if(t.nb.toString() === currentStar.value){
					t.show = true;
				}
				return t;
			})
			setStarList(temp)
		} else {
			let temp = starList.map((t) => {
				if(t.nb.toString() === currentStar.value){
					t.show = false;
				}
				return t;
			})
			setStarList(temp)
		}
		e.preventDefault();
	}
	const displayStar = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<img key={i} className="pixel h-[24px] aspect-[13/14]" src="img/star.png" alt={nb.toString()} style={{float:'left'}}/>);
		}
		return stars;
		
	}
	const displayStarHero = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<div key={i} style={{zIndex:"1"}} className="self-end mb-1"><img className='w-[16px]' src={`/img/star.png`} alt="star" /></div>);
		}
		return stars;
	}
	function computedEsperSkillList() {
		let temp = [...esperList];
        temp = temp.map((esper) =>  {
            let tempEsper = {...esper}		
			if(searchQ !== "") {
				let tempType = typeList.find((t) => t.id === tempEsper.TypeID);
				if(tempType !== undefined) {
					tempEsper.show = tempType.show && (searchKey(tempEsper.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(tempEsper.NickName).toLowerCase().includes(searchQ.toLowerCase()))
				} else {
					tempEsper.show = searchKey(tempEsper.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(tempEsper.NickName).toLowerCase().includes(searchQ.toLowerCase())
				}

			} else {
				let tempType = typeList.find((t) => t.id === tempEsper.TypeID);
				let tempStar = starList.find((s) => s.nb === tempEsper.InitialStar);
				if(tempType !== undefined && tempStar !== undefined) {
					tempEsper.show = tempType.show && tempStar.show;
				} else {
					console.log("tempType undefined"+tempEsper.TypeID);
				}
					
			}
			if(searchParams.get("collection") !== null) {
				let myCollection = searchParams.get("collection");
        		let tCollection = myCollection.split(',');
				if(!tCollection.includes(tempEsper.ID.toString())){
					tempEsper.show = false;
				}
			}
			// don't show esper that is already in the team list
			// eslint-disable-next-line
			teamList.map((team) => {
				if(team !== null) {
					if(team.ID === tempEsper.ID){
						tempEsper.show = false;
					}
				}
			})

			// if filterByCollection is true, ony show esper that is in the collection
			if(filterByCollection) {
				let temp = collection.find((e) => e === tempEsper.ID);
				if(temp === undefined) {
					tempEsper.show = false;
				} else {
					tempEsper.show = true;
				}
			}
            return tempEsper
        })
        setEsperList(temp);
        return temp;
    }
	const selectUnit = (unit) => {
		let temp = [...teamList];
		let isAdd = false;
		for(let i=0;i <temp.length;i++){
			if(temp[i] === null){
				temp[i] = unit;
				isAdd = true;
				break;
			}
		}
		setTeamList(temp);
		if(isAdd) {
			let tempEsperList = [...esperList];
			let tempEsper = tempEsperList.find((e) => e.ID === unit.ID);
			if(tempEsper !== undefined) {
				tempEsper.show = false;
				setEsperList(tempEsperList);
			}
		}
	}
	const removeUnit = (unit) => {
		let temp = [...teamList];
		let isRemove = false;
		for(let i=0;i <temp.length;i++){
			if(temp[i] !== null && temp[i].ID === unit.ID){
				temp[i] = null;
				isRemove = true;
				break;
			}
		}
		setTeamList(temp);
		if(isRemove) {
			let tempEsperList = [...esperList];
			let tempEsper = tempEsperList.find((e) => e.ID === unit.ID);
			if(tempEsper !== undefined) {
				tempEsper.show = true;
				setEsperList(tempEsperList);
			}
		}
	}
	const updateUnit = (unit) => {
		let temp = [...teamList];
		for(let i=0;i <temp.length;i++){
			if(temp[i] !== null){
				if(temp[i].ID === unit.ID){
					temp[i] = unit;
					break;
				}
			}
		}
		setTeamList(temp);
	}

	useEffect(() => {
		computedEsperSkillList()
		// eslint-disable-next-line
    },[searchQ,typeList,starList,searchParams,filterByCollection]);

    const screenShot = () => {
		let element = document.getElementById('teamScreenContainer');
		element.classList.remove('hidden');

		if(showScreenshotStat) {
			Array.prototype.forEach.call(document.getElementsByClassName('stat'),(e) => {
				e.classList.remove('hidden');
			})
		} else {
			Array.prototype.forEach.call(document.getElementsByClassName('stat'),(e) => {
				e.classList.add('hidden');
			})
		}
		const html = document.getElementsByTagName("html")[0];
		const body = document.getElementsByTagName("body")[0];
		html.style.width = 1920 + "px";
		body.style.width = 1920 + "px";

		toPng(document.getElementById('teamScreenContainer'))
		.then(function (dataUrl) {
			download(dataUrl, 'team.png');
			html.style.width = null;
			body.style.width = null;
			element.classList.add('hidden');
			Array.prototype.forEach.call(document.getElementsByClassName('stat'),(e) => {
				e.classList.remove('hidden');
			})
		});
	}
	
    return(
        <>
        <div className='text-right p-2'>
			<button className='exportImg text-right hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => setIsOpen(true)}>{translate("🖼️ Export team screenshot")}</button>
			<Modal
				isOpen={modalIsOpen}
				//onAfterOpen={}
				onRequestClose={() => setIsOpen(false)}
				//style={modalStyles}
				className="Modal w-[90%] md:w-[50%]"
				overlayClassName="Overlay"
				contentLabel="Example Modal"
			>
				<div className='flex flex-col'>
					<div className='flex flex-col p-2 gap-2'>
						<label>Team Name (will be displayed at the top of the image) : </label>
						<input type="text" value={screenshotTitle} onChange={(e) => setScreenshotTitle(e.target.value)} className='bg-[#212932]' placeholder="Team Name..." id="screenshotName"/>
						<div className='flex flex-row gap-2 items-center'>
							<label>Display stats</label>
							<input type="checkbox" checked={showScreenshotStat} onChange={(e) => setShowScreenshotStat(e.target.checked)} className='bg-[#212932] mt-1'/>
						</div>
						<div className='flex flex-row gap-2 items-center'>
							<label>Display relics</label>
							<input type="checkbox" checked={showRelics} onChange={(e) => setShowRelics(e.target.checked)} className='bg-[#212932] mt-1'/>
						</div>
					</div>
					<div className='flex flex-row justify-end gap-2'>
						<button className=' hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => {screenShot();setIsOpen(false)}}>✔️ OK</button>
						<button className='hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => setIsOpen(false)}>❌ Close</button>
					</div>
				</div>
			</Modal>
		</div>
        <div className="team" id="containerTeam">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 justify-center gap-2 items-start" id="gridTeam">
                {teamList.map((unit, i) => (
                    <TeamSlot slot={i} key={i} showRelics={true} displayStat={true} forScreenshot={false} removeUnit={removeUnit} updateUnit={updateUnit} unit={unit} />
                ))}
            </div>
        </div>
		<h3>Nb Esper: {esperList.length}</h3>
		<div className='filter grid md:grid-cols-1 grid-cols-2 md:flex md:flex-row pb-2'>
                <div className="w-full md:w-48">
                    <h3>Type</h3>
                    <button onClick={(e) => toggleAll(e, "type")}>{translate("All")}</button> / <button onClick={(e) => toggleNone(e, "type")}>{translate("None")}</button>
                    {typeList !== [] ?
                        typeList.map((type) => (
                            <div key={"typeList-" + type.name} id={type.id.toString()} className="flex items-center">
                                <input id={`filter-type${type.id}`} onChange={toggleType} name="type[]" checked={type.show} value={type.id.toString()} type="checkbox" className="h-4 w-4 border-gray-300 rounded text-blue-400 focus:ring-indigo-500" />
                                <label htmlFor={`filter-type${type.id}`} className="ml-3 min-w-0 justify-start">
                                    <img className='pixel h-[24px] aspect-[13/14] mr-2' src={'img/type/UnitJob' + type.id.toString() + '.png'} alt={type.name} style={{ float: 'left' }} />
                                    {translate(type.name.toUpperCase())}
                                </label>
                            </div>
                        )) : ''}
                </div>
                <div className="w-full md:w-48">
                    <h3>Stars</h3>
                    <button onClick={(e) => toggleAll(e, "star")}>{translate("All")}</button> / <button onClick={(e) => toggleNone(e, "star")}>{translate("None")}</button>
                    {starList !== [] ?
                        starList.map((star) => (
                            <div key={"starList-" + star.nb} id={star.nb.toString()} className="flex items-center">
                                <input id={`filter-star${star.nb}`} onChange={toggleStar} name="star[]" checked={star.show} value={star.nb} type="checkbox" className="h-4 w-4 border-gray-300 rounded text-blue-400 focus:ring-indigo-500" />
                                <label htmlFor={`filter-star${star.nb}`} className="ml-3 min-w-0 text-black justify-start">
                                    {displayStar(star.nb)}
                                </label>
                            </div>
                        )) : ''}
                </div>
                <div className="w-full md:w-48">
                    <label>{translate('Search')}</label>
                    <div><input type="text" onChange={(e) => search(e)} placeholder={"Name or NickName..."} className='bg-[#212932]' /></div>
                </div>
				<div className="flex flex-row gap-2">
					<label>{translate('Filter by your collection ?')}</label>
					<div style={{paddingTop: '2px'}}><input type="checkbox" value={filterByCollection} onChange={(e) => setFilterByCollection(e.target.checked)} className='bg-[#212932]' /></div>
				</div>
        </div>
			<div className='grid gap-2 lg:grid-cols-7 md:grid-cols-5 grid-cols-2 mb-10'>
                {esperList.filter((h) => h.show === true).map((unit, index) => (
                    <div key={unit.ID.toString()} className="flex flex-row justify-center hover:cursor-pointer" onClick={() => selectUnit(unit)} id={unit.ID.toString()}>
                        <div className='relative bg-[#212932]  shadow-lg rounded-lg w-[128px] aspect-[256/363] flex flex-col justify-end' style={{ imageRendering: '-webkit-optimize-contrast', backgroundPosition: "-40px 0", backgroundSize: "cover", backgroundImage: `url(/img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}_256.png` }}>
                            <div className='absolute'>
                                <img alt="mask" src="img/cards/mask2.png" className='rounded-tr-lg rounded-bl-lg' />
                            </div>
                            <div className='absolute top-0 right-0 rounded-tr-lg rounded-bl-lg'>
                                <img alt="type" src={`img/type/UnitJob${unit.TypeID}.png`} style={{ width: '20px' }} className='rounded-tr-lg rounded-bl-lg' />
                            </div>
                            {displayStarHero(unit.InitialStar)}
                            <div className="z-20 flex flex-row justify-between" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
                                <div className='text-center font-bold text-sm text-white w-full'>
                                    {searchKey("Unit;NickName;" + unit.ID)}
                                    <span className="text-xs"> ({searchKey(unit.Name)})</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
			<div className="hidden flex flex-col bg-[#171e26]" id="teamScreenContainer">
				<div className='text-center customTitle text-3xl mb-2'>{screenshotTitle}</div>
                <div className="grid grid-cols-5 justify-center gap-2 items-start" id="teamScreen">
                    {teamList.map((unit, i) => (
                        <TeamSlot slot={i} key={i} showRelics={showRelics} displayStat={showScreenshotStat} forScreenshot={true} onlyImage={true} removeUnit={removeUnit} updateUnit={updateUnit} unit={unit} />
                    ))}
                </div>
            </div></>
    )
}
export default Main;